"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Lights = function () {
    var lights = [];
    for (var i = 0; i < 12; i++) {
        lights.push(1);
    }
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.wrapper },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container }, lights.map(function (item, idx) { return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.light, " lightRoulette"), key: "light".concat(idx) })); }))));
};
exports.default = Lights;
